<template>
	<v-btn :disabled="loader" :loading="loader" @click="$refs.inputUpload.click()" color="info">
		<v-icon small left>input</v-icon>
		Nhập Excel
		<input
			v-show="false"
			ref="inputUpload"
			type="file"
			@change="onFileSelected"
		/>
	</v-btn>
</template>

<script>
import XLSX from 'xlsx'

export default {
	name: "import-excel-button",
	props: {
		loader: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {};
    },
    methods: {
        onFileSelected: function(e) {
			let files = e.target.files,
				f = files[0];
			let reader = new FileReader();
			let that = this;
			reader.onload = function(e) {
				let data = new Uint8Array(e.target.result);
				let arr = new Array();
				for (let i = 0; i != data.length; ++i)
					arr[i] = String.fromCharCode(data[i]);
				let bstr = arr.join("");

				/* Call XLSX */
				let workbook = XLSX.read(bstr, {
					type: "binary"
				});
				let first_sheet_name = workbook.SheetNames[0];
				let worksheet = workbook.Sheets[first_sheet_name];
				const excel_data = XLSX.utils.sheet_to_json(worksheet, {
					raw: true
				});
				that.$emit("uploaded", excel_data);
			};
			reader.readAsArrayBuffer(f);
		},
    }
};
</script>

<style>
</style>